export default "__VITE_ASSET__BgWwnLOx__"